import styled from '@emotion/styled';

import SkeletonLoader from '../SkeletonLoader';
import { COLORS3, MEDIA_QUERY, SPACING, ZINDEX } from '../../styles/emotion';

export const Container = styled.div`
  z-index: ${ZINDEX.behind};
  position: fixed;
  width: 100%;
  background-color: ${COLORS3.WHITE_100};
`;

export const Row = styled.div`
  border-bottom: 1px solid ${COLORS3.BLACK_030};
  display: flex;
  align-items: center;
`;

export const SharedLoader = styled(SkeletonLoader)`
  line-height: ${SPACING.MD};
  ${MEDIA_QUERY.DESKTOP} {
    line-height: ${SPACING.S24};
  }
`;

export const Promo = styled(Row)`
  padding: 6px 0;
  justify-content: space-around;
`;

export const Primary = styled(Row)`
  padding: 21px ${SPACING.MD};
  justify-content: space-between;
  ${MEDIA_QUERY.DESKTOP} {
    padding: ${SPACING.S24} 64px;
  }
`;

export const Secondary = styled(Row)`
  display: grid;
  grid-gap: ${SPACING.S16};
  padding: ${SPACING.S16} 0;
  margin: 0 auto;
  grid-template-columns: repeat(5, 133px);
  justify-content: center;
`;
